<template>
  <div ref="collapse" class="pt collapse" :id="uid">
    <div
      class="big header"
      :class="{ open: toggle, fold: fold }"
      @click="toggleContainer"
    >
      <slot name="header"></slot>
    </div>
    <div v-if="toggle && fold" class="content pt small">
      <slot name="content"></slot>
    </div>
    <div v-if="inview" class="left p big">
      <slot name="left"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    uid: String,
    fold: Boolean,
    parent: String
  },
  data() {
    return {
      toggle: false,
      inview: false
    };
  },
  mounted() {
    if (this.$route.hash.substring(1) === this.uid) {
      this.toggle = true;
    }
  },
  created() {
    window.addEventListener("scroll", this.inViewport);
  },
  destroyed() {
    window.removeEventListener("scroll", this.inViewport);
  },
  methods: {
    inViewport() {
      let hW = window.innerHeight / 2;
      let center = window.scrollY + hW;
      let top = this.$refs.collapse.offsetTop - 4;
      let height = top + this.$refs.collapse.clientHeight + 4;
      if (center > top && center < height) {
        this.inview = true;
      } else {
        this.inview = false;
      }
    },
    toggleContainer() {
      this.toggle = !this.toggle;
      if (this.fold) {
        if (this.toggle) {
          this.$router.push({
            path: "/" + this.$i18n.locale + "/" + this.parent + "#" + this.uid
          });
        } else {
          this.$router.push({
            path: "/" + this.$i18n.locale + "/" + this.parent
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.collapse {
  position: relative;
  padding-bottom: var(--lh);
  border-bottom: var(--b) solid black;
  .left {
    position: fixed;
    top: 0;
    left: 0;
    padding-top: calc(3 * var(--lh));
    width: 50%;
    @media only screen and (max-width: 768px) {
      padding-top: calc(3 * var(--lh));
    }
  }
  .header.fold {
    cursor: pointer;
    .first {
      padding-right: calc(3 * var(--lh));
      position: relative;
      @media only screen and (max-width: 768px) {
        padding-right: calc(2 * var(--lh));
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        width: calc(1 * var(--bs));
        height: 0;
        border-top: var(--b) solid #000;
        transform: rotate(90deg);
      }
      &:before {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        width: calc(1 * var(--bs));
        height: 0;
        border-top: var(--b) solid #000;
      }
    }
    &.open {
      .first {
        &:before {
          transform: rotate(45deg);
        }
        &:after {
          transform: rotate(135deg);
        }
      }
    }
  }
  &:last-of-type {
    padding-bottom: 0;
    border-bottom: 0;
  }
  .grid {
    display: grid;
    grid-gap: var(--lh);
    grid-template-columns: 30% 70%;
    @media only screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }
}
</style>
